/** Default tenant_settings values applied on platform tenant create — catalogofworks. */
export const tenantDefaults = {
  listOnPlatform: false,
  allowGuestCart: true,
  allowGuestOrders: false,
};
